export enum TRANSFER_TO_ASSET {
  FORM_DATA = "tta_data",
}
